
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Innovacrystahireforcorporateevents() {



  const cardData =
{
  keyword: 'Innova Crysta Hire for Corporate Events in Pune',
  heading: 'eTravo: Innova Crysta Hire for Corporate Events in Pune',
  headingDescription: 'Looking for reliable and luxurious transport for your business needs? eTravo offers Innova Crysta hire for corporate events in Pune, ideal for executive transfers, staff travel, and important meetings. Known for its comfort, safety, and professional appeal, the Innova Crysta is a top choice for business-class travel. Our fleet is maintained to the highest standards, with GPS tracking, AC, and experienced drivers. Whether it’s a high-stakes client meeting or team transport for events, eTravo ensures a seamless experience with our premium Innova Crysta services.',

  top: 'Top Places to Visit in Pune for Corporate Events',
  topPlaces: [
    {
      title: 'JW Marriott Hotel Pune',
      description: 'A top-tier venue for board meetings, seminars, and corporate gatherings. Its central location, spacious halls, and exceptional hospitality make it a preferred destination for executives arriving in eTravo’s Innova Crysta vehicles.'
    },
    {
      title: 'EON IT Park',
      description: 'As one of Pune’s leading IT and business hubs, EON IT Park in Kharadi sees frequent business travel. Our Innova Crysta fleet serves corporate staff and executive teams commuting to and from this location daily.'
    },
    {
      title: 'Westin Pune Koregaon Park',
      description: 'A high-end hotel perfect for business conferences and networking events. eTravo offers smooth and professional travel to this venue with fully air-conditioned Innova Crystas that match the tone of your elite events.'
    },
    {
      title: 'Balewadi High Street',
      description: 'A vibrant destination with modern office spaces, coworking hubs, and event venues. Our Innova Crysta services are frequently used for transporting teams attending meetups, seminars, and exhibitions here.'
    },
    {
      title: 'ICC Trade Towers',
      description: 'Located on Senapati Bapat Road, this corporate center is ideal for business exhibitions and B2B meetings. eTravo ensures timely arrival of guests and employees with our punctual and premium transport service.'
    },
    {
      title: 'Hyatt Regency Pune',
      description: 'Known for its large conference halls and boardrooms, this venue hosts corporate events, leadership summits, and brand launches. eTravo provides door-to-door Innova Crysta services for attendees and organizing teams.'
    },
    {
      title: 'Magarpatta City',
      description: 'This integrated township includes IT offices and business convention halls. eTravo supports daily executive movement and event-related group transport through our Crysta fleet in this area.'
    },
    {
      title: 'O Hotel Pune',
      description: 'A boutique business hotel in Koregaon Park that often hosts private executive dinners and small group conferences. Our Innova Crysta vehicles offer discreet, comfortable, and timely travel for such occasions.'
    },
    {
      title: 'Pune International Exhibition & Convention Centre',
      description: 'This large-scale venue in Moshi is often chosen for corporate expos and trade fairs. eTravo transports staff, partners, and equipment using its versatile Innova Crysta fleet.'
    },
    {
      title: 'Weikfield IT Citi Info Park',
      description: 'A hub for IT and multinational firms near Viman Nagar. Daily office commutes and event transfers are conveniently managed by eTravo’s chauffeur-driven Innova Crysta rentals.'
    }
  ],

  services: [
    {
      name: 'Corporate Innova Crysta Rental Pune',
      description: 'Premium-grade Innova Crysta rentals tailored for corporate events in Pune. Ideal for executive transfers, team outings, or VIP pickups, our vehicles combine luxury, performance, and reliability for your corporate transport needs.'
    },
    {
      name: 'AC Innova Hire for Business Events Pune',
      description: 'Our air-conditioned Innova Crystas are perfect for transporting corporate teams to business events, ensuring comfort even during long commutes in Pune’s traffic and weather.'
    },
    {
      name: 'Executive Car Rental for Corporate Pune',
      description: 'eTravo’s executive car rental services feature fully equipped Innova Crystas, ensuring a luxurious travel experience for senior managers, directors, and important guests.'
    },
    {
      name: 'Staff Transport in Innova Crysta Pune',
      description: 'For employee groups attending training, seminars, or corporate functions, our spacious Innova Crysta cabs provide safe, timely, and comfortable travel solutions.'
    },
    {
      name: 'Business Meeting Car Rental Pune',
      description: 'Whether it’s a one-off client visit or a day packed with back-to-back meetings, our on-demand Innova Crysta rental service ensures your executives arrive on time and in style.'
    },
    {
      name: 'Airport Transfer Innova Pune',
      description: 'Smooth airport pickups and drops for your business guests, with professional chauffeurs and real-time flight tracking to ensure timely service and hospitality.'
    },
    {
      name: 'Innova Crysta Fleet for Corporates Pune',
      description: 'eTravo maintains a dedicated fleet of Innova Crystas available for long-term or short-term corporate use. Ideal for large companies and event organizers requiring bulk bookings.'
    },
    {
      name: 'Reliable Innova Rental Pune',
      description: 'Known for punctuality and reliability, our Innova Crysta rentals serve multiple corporate clients daily across Pune. Fully maintained and sanitized for peace of mind.'
    },
    {
      name: 'Affordable Corporate Innova Hire Pune',
      description: 'Get premium travel at competitive rates. Our corporate pricing plans make it easy to scale your transportation without compromising on quality or comfort.'
    },
    {
      name: 'Innova for Office Commute Pune',
      description: 'Daily office commutes for executives or senior staff made easy with our scheduled Innova Crysta rides, offering door-to-door convenience and comfort.'
    },
    {
      name: 'Innova for Client Meetings Pune',
      description: 'Enhance your company’s image by sending a luxurious Innova Crysta to pick up clients or partners for important discussions or site visits.'
    }
  ],

  tableData: [
    ['Corporate Innova Crysta Rental Pune', 'AC Innova Hire for Business Events Pune'],
    ['Executive Car Rental for Corporate Pune', 'Staff Transport in Innova Crysta Pune'],
    ['Business Meeting Car Rental Pune', 'Airport Transfer Innova Pune'],
    ['Innova Crysta Fleet for Corporates Pune', 'Reliable Innova Rental Pune'],
    ['Affordable Corporate Innova Hire Pune', 'Innova for Office Commute Pune'],
    ['Innova for Client Meetings Pune', '']
  ],




"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Fleet for Business Travel",
        "WhyChoosedescription": "eTravo provides high-end Innova Crysta vehicles that are ideal for executive transport, corporate meetings, and special events across Pune. With luxurious seating, climate control, and spacious interiors, it’s the preferred choice for business-class comfort."
    },
    {
        "WhyChooseheading": "Perfect for Meetings, Seminars, and VIP Guest Movements",
        "WhyChoosedescription": "Our Innova Crysta services are tailored for business use—whether you need a vehicle for transporting board members, event speakers, or international clients to and from hotels, airports, and event venues."
    },
    {
        "WhyChooseheading": "Customizable Packages for Hourly and Full-Day Rentals",
        "WhyChoosedescription": "Choose from flexible rental durations that suit your event schedule. Be it a few hours or multiple days, our pricing models are designed to offer both convenience and value for corporate clients."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Corporate Etiquette",
        "WhyChoosedescription": "Our chauffeurs are trained in professional conduct, punctual, and well-groomed—ensuring your guests experience reliable and respectful service at every touchpoint."
    },
    {
        "WhyChooseheading": "GPS-Enabled Vehicles for Real-Time Monitoring",
        "WhyChoosedescription": "Track your fleet live with GPS-enabled Innova Crystas. Event managers and corporate teams can receive live ETA updates and route tracking for better coordination."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Safety-Compliant Rides",
        "WhyChoosedescription": "All vehicles are sanitized before every ride and equipped with seat belts, GPS, first aid kits, and fire extinguishers, meeting all safety regulations for corporate transport."
    },
    {
        "WhyChooseheading": "GST Invoicing and Corporate Billing Convenience",
        "WhyChoosedescription": "Get monthly invoices, GST-compliant billing, and itemized breakdowns that simplify expense tracking and reimbursements for your accounts and procurement departments."
    },
    {
        "WhyChooseheading": "Dedicated Transport Coordinator for Events",
        "WhyChoosedescription": "For larger events and multiple bookings, we assign a dedicated event manager to oversee arrivals, manage scheduling, and coordinate end-to-end transport operations."
    }
]

}

const faqData = [
    [
        {
            question: 'What makes Innova Crysta ideal for corporate events in Pune?',
            answer: 'Innova Crysta offers premium comfort, ample space, dual-zone AC, and professional appeal—making it the top choice for business meetings, VIP travel, and event logistics.'
        },
        {
            question: 'Can we book the Innova Crysta for a few hours only?',
            answer: 'Yes, eTravo offers flexible booking durations—hourly, half-day, full-day, or multi-day—based on your event requirements and guest schedules.'
        },
        {
            question: 'Are the drivers trained for corporate client service?',
            answer: 'Yes, our chauffeurs are professionally trained in etiquette, punctuality, and safety standards to ensure a smooth experience for your executives and clients.'
        },
        {
            question: 'Do you provide real-time tracking for Innova Crysta bookings?',
            answer: 'Absolutely. All vehicles are GPS-enabled and can be tracked live for accurate ETAs, route verification, and better coordination.'
        },
        {
            question: 'Does the service include billing with GST and itemized charges?',
            answer: 'Yes, all our corporate clients receive monthly or per-trip invoices with GST compliance and clear cost breakdowns for easier accounting.'
        },
        {
            question: 'Is there support available during the event for transport coordination?',
            answer: 'Yes, we provide a dedicated account or event coordinator for large bookings to manage logistics, resolve queries, and ensure everything runs on time.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Ritesh Bhalerao',
        designation: 'Admin Head, OrionTech Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“Our leadership team used eTravo’s Innova Crysta fleet for a tech summit in Pune. The vehicles were in excellent condition and the entire operation was smoothly managed.”'
    },
    {
        name: 'Ms. Shraddha Joshi',
        designation: 'HR Manager, Crestline Ventures',
        rating: [1, 1, 1, 1, 1],
        text: '“We were impressed by the level of service during our corporate seminar. Clean Crystas, polite drivers, and on-time pickups made everything effortless.”'
    }
];














    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Hire for Corporate Events in Pune",
  "image": "https://www.etravo.in/images/keyword/innova-crysta-corporate-hire-pune.jpg",
  "description": "Hire Innova Crysta for corporate events in Pune with eTravo. Experience comfortable and reliable executive transport for business meetings, staff pickups, airport transfers, and office commutes. Choose AC luxury or budget-friendly Innova options with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3147"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1799",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/innova-crysta-hire-corporate-events-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Innova Crysta Hire for Corporate Events in Pune | eTravo </title>
  <meta 
    name="description" 
    content="Book AC Innova Crysta for corporate events, staff transport, airport transfers, and client meetings in Pune. Affordable and reliable executive car rental services from eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystahireforcorporateevents;